export const PAYOUT_INFO = "PAYOUT_INFO";


const initialState = null; 

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case PAYOUT_INFO:
            return action.payload;
        default:
            return state;
    }
}

const storeMapping = {partnerPayouts: reducer};

export const partnerPayoutsSelector = (state) => state.partnerPayouts;

export default storeMapping;